// extracted by mini-css-extract-plugin
export default {"AppBlog":"AppBlog_AppBlog__FUa5Y","AppBlog__cards":"AppBlog_AppBlog__cards__JPfC2","AppBlog__arrows":"AppBlog_AppBlog__arrows__RemM0"};